import React from 'react';
import {
  Box,
  makeStyles,
} from '@material-ui/core';
import { useSelector } from 'react-redux';
import ApplicationStatusDetails from '../profile/profileForms/ApplicationStatus';
import client from 'graphql/client';
import isEmpty from 'lodash/isEmpty';
import { UPDATE_STUDENT_PROFILE } from '../../../graphql/student/Profile';
import Cookies from 'universal-cookie';
import Layout from './components/Layout';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiCardContent-root > .MuiGrid-root': {
      display: 'flex',
      justifyContent: 'center',
    },
  }
}));

const cookies = new Cookies();

const AppStatus = (props) => {
  const classes = useStyles();
  const user = useSelector((u) => u.user.user);
  const profile = useSelector((u) => u.student.profile);
  const { history } = props;
  const step = 7;

  const checkOnBoardingPending = () => {
    const {
      profile: {
        college_info,
        highschool_info,
        onboarding_done,
        application_progress
      },
    } = props;
    if (onboarding_done) {
      return false;
    }
    return (
      isEmpty(college_info) ||
      isEmpty(highschool_info) ||
      isEmpty(application_progress) ||
      !college_info?.completed ||
      !application_progress?.completed ||
      !highschool_info?.completed
    );
  };

  const onFinish = async () => {
    await cookies.set('onboarding_skip', true);
    const onBoardingPending = await checkOnBoardingPending();
    !onBoardingPending &&
      (await client.mutate({
        mutation: UPDATE_STUDENT_PROFILE,
        variables: {
          id: user.id,
          input: {
            onboarding_done: true,
          },
        },
      }));
    await history.push(`/`);
  };

  return (
    <Layout step={step} showBack stepLabel={`Onboarding quiz - Step ${step}/7 `}>
      <Box className={classes.root}>
        <ApplicationStatusDetails
          editable
          user={user}
          college_info={profile.application_progress}
          saveText="Finish"
          step={step}
          onFinish={onFinish}
          onSkip={onFinish}
          disableCard
          isSkip
          {...props}
        />
      </Box>
    </Layout>
  );
};

export default AppStatus;
